import printLogService from '@/api/print-log-service';

const state = {
  printList: null,
  printListPagination: {},
  printListFilterParams: {},
};

const mutations = {
  SET_PRINT_LIST(state, { data, current_page, per_page, total }) {
    state.printList = data;
    state.printListPagination = {
      current_page,
      per_page,
      total,
    };
  },

  SET_FILTER_PARAMS(state, params) {
    state.printListFilterParams = params;
  },
};

const actions = {
  fetchPrintList({ state, commit }, params) {
    commit('SET_FILTER_PARAMS', params);
    return printLogService.getList(params).then((res) => {
      commit('SET_PRINT_LIST', res.data);
      if (params.page !== state.printListFilterParams.page) {
        window.scrollTo(0, 0);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
